// Components
import NodeActionBased from 'Components/flowChart/components/NodePreview/components/NodeActionBased';
import NodeDelay from 'Components/flowChart/components/NodePreview/components/NodeDelay';
import NodeDestination from 'Components/flowChart/components/NodePreview/components/NodeDestination';
import NodeFilter from 'Components/flowChart/components/NodePreview/components/NodeFilter';
import NodeScheduled from 'Components/flowChart/components/NodePreview/components/NodeScheduled';
import NodeUpdateInfo from 'Components/flowChart/components/NodePreview/components/NodeUpdateInfo';
import NodeUpdateSegment from 'Components/flowChart/components/NodePreview/components/NodeUpdateSegment';
import NodeWaitEvent from 'Components/flowChart/components/NodePreview/components/NodeWaitEvent';
import NodeWaitEventHappened from 'Components/flowChart/components/NodePreview/components/NodeWaitEventHappened';
import NodeWaitEventTimeout from 'Components/flowChart/components/NodePreview/components/NodeWaitEventTimeout';
import NodeYes from 'Components/flowChart/components/NodePreview/components/NodeYes';
import {NodeWFRNodePreview} from './components/NodeWFRNode';

// Constants
import {NODE_TYPE} from 'Components/flowChart/constant';

export const NODE_PREVIEW_COMPONENT = {
	[NODE_TYPE.EVENT_BASED]: NodeActionBased,
	[NODE_TYPE.SCHEDULED]: NodeScheduled,
	[NODE_TYPE.DELAY]: NodeDelay,
	[NODE_TYPE.FILTER]: NodeFilter,
	[NODE_TYPE.CONDITION_YES]: NodeYes,
	[NODE_TYPE.WAIT_EVENT]: NodeWaitEvent,
	[NODE_TYPE.WAIT_EVENT_HAPPENED]: NodeWaitEventHappened,
	[NODE_TYPE.WAIT_EVENT_TIMEOUT]: NodeWaitEventTimeout,
	[NODE_TYPE.UPDATE_INFO]: NodeUpdateInfo,
	[NODE_TYPE.UPDATE_SEGMENT]: NodeUpdateSegment,
	[NODE_TYPE.DESTINATION]: NodeDestination,
	[NODE_TYPE.GO_TO]: null,
	[NODE_TYPE.SPLIT_BRANCH]: null,
	[NODE_TYPE.AB_SPLIT_CONTROL_NODE]: null,
	[NODE_TYPE.END]: null,
	[NODE_TYPE.CLASSIC_LIST_BRANCH]: null,
	[NODE_TYPE.PARALLEL_LIST_BRANCH]: null,
	[NODE_TYPE.CONDITION_NO]: null,
	[NODE_TYPE.WFR_NODE]: NodeWFRNodePreview,
	[NODE_TYPE.AB_SPLIT]: null,
	[NODE_TYPE.AB_SPLIT_NODE]: null
};

export const FORMAT_HOUR = 'hh:mm A';

export const FORMAT_FULL_DATE = 'MMM DD, YYYY - hh:mm A';
